@file:OptIn(InternalResourceApi::class)

package resursedeblocat.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/resursedeblocat.composeapp.generated.resources/"

@delegate:ResourceContentHash(199_528_160)
internal val Res.drawable.brand_image: DrawableResource by lazy {
      DrawableResource("drawable:brand_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/brand_image.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(470_159_096)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_013_637_675)
internal val Res.drawable.ic_google: DrawableResource by lazy {
      DrawableResource("drawable:ic_google", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_google.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_737_119_405)
internal val Res.drawable.lock: DrawableResource by lazy {
      DrawableResource("drawable:lock", setOf(
        ResourceItem(setOf(), "${MD}drawable/lock.svg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("brand_image", Res.drawable.brand_image)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_google", Res.drawable.ic_google)
  map.put("lock", Res.drawable.lock)
}
